module.exports = __webpack_public_path__ + "img/8.451e0116.svg";